angular.module('iqxCore')
.service('permRegistrationSvc', function () {
	// Step 0: EULA
	// Step 1: Capture Basic Details
	// Step 2: Register to Division
	// Step 3: Register to Department
	// Step 4: Get CV
	// Step 5: FINISH
	
	var svc=this
	svc.step=0
	svc.register={}

	svc.resetSvc=function(){
		svc.step=0
		svc.register={}
		svc.backpressed=false
	}

    svc.nextStep=function(scope, goback){
        svc.step++
    }
})

// Step 0: EULA
.controller('RegisterPermCtrl', function ($scope, ApplicationSvc, permRegistrationSvc, loginSvc){
	$scope.regSvc=permRegistrationSvc
	$scope.step=$scope.regSvc.step

    if (ApplicationSvc.currentUser.UserClass!='CANDIDATE') {
        loginSvc.setLoggedOut()
    } else {
        if (ApplicationSvc.currentUser.UserClass=='CANDIDATE') {
            ApplicationSvc.currentUser.UserClass="PRE-CANDIDATE"
            permRegistrationSvc.step=2

            if ($routeParams.continuefrom) {
                permRegistrationSvc.step=$routeParams.continuefrom
            }
        }
    }

	$scope.acceptTerms = function(){
		permRegistrationSvc.nextStep($scope)
	}

    $scope.steps=4
})

// Step 1: Capture Basic Details
.controller('RegisterPermWizard1Ctrl', function ($scope, permRegistrationSvc, FormSvc, QuestionnaireSvc, ApplicationSvc, ApiSvc, loginSvc, $timeout, $location){
    $scope.showEmailExists=false

	FormSvc.setOptions($scope,{
		fetchAPI:{/* Empty Fetch */},
		saveAPI:'register/candidate',
		notLoggedIn:true, // New candidate so obviously not yet logged in
		autoEdit:true, // Switch form straight to edit mode
		saveCleanFields:true, // All fields sent, whether or not dirty
		savePrefix:'p',
		questionnaire:{
			tagTarget:'tags',
			displayGroup:'PERMREG',
			tagLocation:'P',
			postVar:'qanswers'
		}
    })
    
    $scope.dateOptions.datepickerMode = 'year'
    $scope.dateOptions.initDate = moment().subtract('30', 'y').toDate()

    $scope.checkLogin=function(login){
        return $timeout(() => {
            return $scope.fetch({
                fetchAPI:'callresult_/NetCheckLoginExists?pLogin='+login,
                fetchTarget:'logincheckrtrn',
                multiRow:false,
                notLoggedIn:true
            })
            .then(function(){
                switch ($scope.logincheckrtrn.pResult) {
                    case '1:~Registration':
                        // It's a new candidate
                        $scope.showEmailExists=false
                    break
                    case '0:~Login':
                        $scope.showEmailExists=true
                    break
                }
            })
        }, 500)
    }

	$scope.getRequiredFields=function(){
		return ApiSvc.fetch($scope,{
			fetchAPI:'callresult_/NetGetRegRequired',
			fetchTarget:'requiredFields',
			multiRow:false,
			notLoggedIn:true
		})
		.then(function(){
			$scope.requiredFields = JSON.parse($scope.requiredFields.JSON)
		})
	}

	$scope.update=function () {  // Over-ride the default update() called by the Register button
		return FormSvc.update($scope,true)  // Save only - do not do the fetch
		.then(function(res) {
			ApplicationSvc.isEditing=false
			loginSvc.setLoggedIn(res, true)
      .then(function(){
        ApplicationSvc.onRegisterPage = true
        ApplicationSvc.currentUser.UserClass="PRE-CANDIDATE"
  
        permRegistrationSvc.nextStep($scope)
      })
		})
	}

	$scope.saveButtonCaption="Continue"

	$scope.$watch('theRecord.Email', function(newValue, oldValue) {
		$scope.theRecord.UserName=newValue  // Email address is default username which they can then edit
	})

    $scope.passwordOpts()
    $scope.getRequiredFields()
    .then(function(){
      $scope.fetch()  // Initialise
    })
})

// Step 2: Register to Division
.controller('RegisterPermWizard2Ctrl', function ($scope, FormSvc, ApplicationSvc, permRegistrationSvc){
    ApplicationSvc.onRegisterPage = true
    FormSvc.setOptions($scope,{/* No Options Needed - Just neeed the Svc */})

    $scope.iconExists=function(icon){
        if(icon) { 
            var url = '/assets/registericons/'+icon+'.png'
            var request = new XMLHttpRequest()
            request.open('HEAD', url, false)
            request.send()
            if(request.status == 200 && request.responseURL.includes('.png')) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    }

    $scope.getDivisions=function(){
        return $scope.fetch({
            fetchAPI:'callresult/NetDivisionList',
            fetchTarget:'DivisionList',
            multiRow:true
        }).then(function(){
          // check for icons
          angular.forEach($scope.DivisionList,function(d){d.iconExists=$scope.iconExists(d.DivisionID)})
        })
    }

    $scope.selectDivision=function(DIV){
        permRegistrationSvc.register.division=DIV
        permRegistrationSvc.nextStep($scope)
    }

    // init
    $scope.getDivisions()
})

// Step 3: Register to Department
.controller('RegisterPermWizard3Ctrl', function ($scope, FormSvc, permRegistrationSvc){
	FormSvc.setOptions($scope,{
	    fetchAPI:{/* Empty Fetch */},
	    notLoggedIn:false, // New candidate so obviously not yet logged in
	    autoEdit:true, // Switch form straight to edit mode
	    saveCleanFields:true // All fields sent, whether or not dirty
	})

    $scope.iconExists=function(icon){
        if(icon) { 
            var url = '/assets/registericons/'+icon+'.png'
            var request = new XMLHttpRequest()
            request.open('HEAD', url, false)
            request.send()
            if(request.status == 200 && request.responseURL.includes('.png')) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    }

    $scope.getDepartments=function(Division){
        return $scope.fetch({
            fetchAPI:'callresult/NetDepartmentList?pDivisionID='+permRegistrationSvc.register.division,
            fetchTarget:'DepartmentList',
            multiRow:true
        }).then(function(){
          // check for icons
          angular.forEach($scope.DepartmentList,function(d){d.iconExists=$scope.iconExists(d.DepartmentID)})
        })
    }

    $scope.update=function () {  // Over-ride the default update() called by the Register button
        $scope.theRecord={
            'pdepartmentid':permRegistrationSvc.register.department,
            'pperm':1
        }
        FormSvc.setSubmitted($scope,true)
        if (true){
            return FormSvc.update($scope,true)  // Save only - do not do the fetch
            .then(function(res) {
                return $scope.exec('call/NetCandidateDivisionRegister',{pDivisionID:permRegistrationSvc.register.division})
            })
            .then(function(res) {
                $scope.exec('call/NetCandidateDepartmentRegister',{
                	pdepartmentid: permRegistrationSvc.register.department, 
                	ptemp: 0, 
                	pperm: 1
                })        
                permRegistrationSvc.nextStep($scope)                
            })
        } else {
          FormSvc.alert(false, "Please check that you have completed all the required fields and there are no invalid values", "error")
        }
    }

    $scope.selectDepartment=function(dept){
        $scope.showTermsAndConditions=false

        permRegistrationSvc.register.DepartmentName=dept.DepartmentName
        permRegistrationSvc.register.department=dept.DepartmentID
        permRegistrationSvc.register.departmentTemp=0
        permRegistrationSvc.register.departmentPerm=1
        $scope.update()
    }
    // Init
    $scope.getDepartments()
})

// Step 4: Get CV
.controller('RegisterPermWizard4Ctrl', function ($scope, FormSvc, permRegistrationSvc, $q, $timeout, ApplicationSvc, ApiSvc, Upload){
	FormSvc.setOptions($scope,{fetchAPI:{}, doNotPreventNav:true, autoEdit:true})
    $scope.params.PDFCVDOCTYPE = $scope.PDFCVDOCTYPE || ''

	$scope.$parent.$parent.CVUploadNotDone=true
	$scope.CVUploadNotDone=true

    if (!$scope.params.PDFCVDOCTYPE) {
        $scope.uploadTypes={
            "doc":{
                "value":"primary_cv",
                "descrip":"Word Document (.doc, .docx)"
            }
        }
    } else {
        $scope.uploadTypes={
            "doc":{
                "value":"primary_cv",
                "descrip":"Word Document (.doc, .docx)"
            },
            "pdf":{
                "value":$scope.params.PDFCVDOCTYPE,
                "descrip":"Portable Document Format (.pdf)"
            }
        }
    }
	$scope.docType="primary_cv"
    $scope.getUserID=function(){
        return $scope.fetch({fetchAPI:'callresult/NetGetWebUserIDs',fetchTarget:'xPerson'})
    }

    $scope.uploadSelect = function (files, file, event) {
        $scope.theForm.CVfile.$touched = true
    }

    $scope.uploadComplete = function () {
        $scope.reset()
        if ($scope.theForm) { // Without this - the form will display "no file selected" error after upload complete!
            $scope.theForm.CVfile.$touched = false
        }
        $scope.setEditing(true)  // bodge to allow next upload
        ApplicationSvc.preventNavIfEditing=false // allows you to move to new page without error after changing image
        $scope.uploadProgress = ''
        $scope.uploadError = ''
        $scope.theRecord = {}
    }

    $scope.uploadFileName = function () {
        if ($scope.theRecord.CVfile) {
            return $scope.theRecord.CVfile.name
        } else {
            return 'Select CV'
        }
    }

    $scope.triggerUploader=function(){
        document.getElementById('CVfile').click()
    }

    $scope.showUploadProgress = function (evt) {
            var s = "Uploading ..."
            if (evt && evt.total) {  // progress callback
                s = s + parseInt(100.0 * evt.loaded / evt.total) + '%'
            }
            $scope.uploadProgress = s
    }

    $scope.uploadExecute = function () {
            $scope.setSubmitted(true) // Ensure all validation errors appear
            $scope.uploadError = ''
            $scope.showUploadProgress()
            Upload.upload({
                url             : '/api/document/upload',
                file            : $scope.theRecord.CVfile,
                fileFormDataName: 'file',
                headers         : {'X-Auth': ApplicationSvc.currentUser.token},
                fields:{
                    'Type':$scope.docType,
                    'Description':"CV",
                    'PersonID':$scope.xPerson.PersonID
                }
            })
                .then(function (res) {
                    ApiSvc.CheckIQXResult(res.data)  // Checks the IQXResult construct and, if failed, throws exception with the message
                    $scope.uploadProgress = "Upload Complete"
                    return $timeout(function () {
                    }, 2000)  // Display the Upload complete message for 2 seconds before refreshing and cleaning up
                }, null, $scope.showUploadProgress) // 3rd arg is the progress callback
                .then(function () {
                    $scope.$parent.$parent.CVUploadNotDone=false
                    $scope.CVUploadNotDone=false
                    $scope.uploadComplete()
                })
                .catch(function (err) {
                    $scope.uploadProgress = ''
                    return $q.reject($scope.uploadError = ApiSvc.ExtractError(err))
                })
    }

    $scope.next=function(){
        $scope.regSvc.nextStep($scope)
    }

    $scope.uploadComplete()
    $scope.getUserID()
})

// Step 5: FINISH
.controller('RegisterPermWizard5Ctrl', function ($scope, FormSvc, permRegistrationSvc, ApplicationSvc, $location){
	FormSvc.setOptions($scope,{
	    fetchAPI:{/* Empty Fetch */},
	    notLoggedIn:false, // New candidate so obviously not yet logged in
	    autoEdit:true, // Switch form straight to edit mode
	    saveCleanFields:true // All fields sent, whether or not dirty
	})
	
    $scope.exec('call/NetCandidateSetRegistrationComplete',{})
    .then(function(){
      ApplicationSvc.currentUser.UserClass='CANDIDATE'
      ApplicationSvc.onRegisterPage = false
      $location.url("home")
    })
})